export const ChartConstants = {
  DEFAULT_LINE_COLOR: '#666666',
  LINE_CHARTS_TICK_INTERVALS: 5,
  MAX_NUMBER_OF_SIGNAL_ON_TEXT_WIDGET: 30,
  MAX_NUMBER_OF_SIGNAL_ON_BAR_WIDGET: 10,
  MAX_NUMBER_OF_SIGNAL_ON_PIE_WIDGET: 10,
  MAX_INTERVAL_MINUTES : 120,
  TOOLTIP: {
    BACKGROUND_COLOR: '#FFFFFF',
    BORDER_WIDTH: 1,
    BORDER_COLOR: '#666666',
    DEFAULT_TIME_FORMAT: '%H:%M:%S - %Z'
  },
  DEFAULT_CHART_SETTINGS: {
    SIGNAL: {

      COLORS: {
        MAIN: 4549329,
        AREA1: 5619515, //success
        AREA2: 14540557, //warning
        AREA3: 14635859 //error
      },

    },
  }
};
